import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9cszrbcd83e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="8bch7bk3tea">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-51" data-mp="57xr9l719hp7">
            Une meilleure façon d&apos;enseigner la musique
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-52" data-mp="3rgyr74fakicv">
            De l&apos;Enseignant Débordé au{' '}
            <span className="italic text-grape" data-id="element-53" data-mp="3dj0qh1tw8kfu">Guide Inspirant.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-54" data-mp="3ihv5dsoqpouo">
            Musique Prête™ transforme des heures de planification en un système
            « ouvrez et enseignez ». Entrez dans chaque leçon avec un plan
            clair, des activités significatives et la confiance nécessaire pour
            faire vivre la musique à vos élèves.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-55" data-mp="1f7r5jf9fqmxz">
          <div className="grid md:grid-cols-2" data-id="element-56" data-mp="1t070dss6nent">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-57" data-mp="1o1dog4sjnvpr">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-58" data-mp="1o3ypirl0q7mg">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="wb7q6881g2sz" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-60" data-mp="1aa7dncjtebnk">
                Le coût de repartir de zéro chaque jour
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-61" data-mp="15dqu6vnk8lgt">
                AVANT
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-62" data-mp="2gphu4qb488sg">
                La vieille méthode épuisante.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-63" data-mp="2otbnycro4ome">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-64" data-mp="2sux90lecw97o">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-65" data-mp="32qi748gb0pc5" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-66" data-mp="2f15vl1xi856o">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-67" data-mp="2ezmjzomsmib8">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="1mdjuq1fnveni" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-69" data-mp="1rb39r3k6nvgi">
                Le système Musique Prête™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-70" data-mp="1jq9d85rozg3m">
                AVEC MUSIQUE PRÊTE™
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-71" data-mp="19sv0oh8w3bgl">
                Votre nouvelle réalité.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-72" data-mp="14xfodtqj5nma">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-73" data-mp="10vkq6y3wbqcq">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-74" data-mp="r1kbq5mq58rc" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-75" data-mp="d4f9kgq4su1d">
            Un système complet pour planifier moins et enseigner avec plus de
            sens.
          </p>
        </div>
      </div>
    </section>;
}